/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertShiftTemplateRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {UpsertShiftTemplateResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const upsertShiftTemplate = (request: UpsertShiftTemplateRequest, options?: CashRequestOptions) => post<UpsertShiftTemplateRequest, UpsertShiftTemplateResponse>("/2.0/cash/upsert-shift-template", request, {...options, rejectOnError: true })